import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class PlanesService extends BaseService<any>{

  private static PLAN_RESOURCE: string = "/planes";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public savePlan(plan: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (plan.id == null) {
      this.post(BaseService.URL_BASE + PlanesService.PLAN_RESOURCE, plan, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + PlanesService.PLAN_RESOURCE, plan, options, onSuccess);
    }
  }

  public deletePlan(plan: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + PlanesService.PLAN_RESOURCE + "/" + plan.id, options, onSuccess);
  }

  public getPlan(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + PlanesService.PLAN_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getPlanes(planFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + PlanesService.PLAN_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/planes.service.ts